import React from 'react';
import { createPortal } from 'react-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isMarketingProductPath } from '../../utils/marketingProduct';
import { MARKETING_HOME_PATH } from '../modules/Marketing/constants/MarketingNavConstants';

const PRODUCT_SWITCHER_ROOT_ID = 'product-switcher-root';
const CRM_HOME_PATH = `/retailers/${ENV.SLUG}/dashboard`;

const BUTTON_BASE = 'tw-appearance-none tw-border-0 focus:tw-outline-none tw-cursor-pointer tw-transition-all tw-duration-200 tw-rounded-full tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-leading-none';

const tabClassName = (active) => (
  active
    ? `${BUTTON_BASE} tw-bg-blue-500 tw-text-white tw-shadow-sm`
    : `${BUTTON_BASE} tw-bg-transparent tw-text-gray-600 hover:tw-bg-gray-200/80`
);

const ProductSwitcherMC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation('Routes');
  const { retailer_info } = useSelector((reduxState) => reduxState.retailerUsersReducer);
  const marketingActive = isMarketingProductPath(location.pathname);
  const mountNode = document.getElementById(PRODUCT_SWITCHER_ROOT_ID);

  const handleCrmClick = () => {
    if (!marketingActive) return;
    navigate(CRM_HOME_PATH);
  };

  const handleMarketingClick = () => {
    if (marketingActive) return;
    navigate(MARKETING_HOME_PATH);
  };

  if (!mountNode || !retailer_info?.marketing_iq_enabled) return null;

  return createPortal(
    <div className="tw-wrapper tw-flex tw-h-full tw-items-center">
      <nav
        className="tw-inline-flex tw-shrink-0 tw-items-center tw-gap-1 tw-rounded-full tw-bg-gray-100 tw-p-1"
        aria-label={t('product_switcher.aria_label')}
      >
        <button
          type="button"
          className={tabClassName(!marketingActive)}
          onClick={handleCrmClick}
          aria-current={!marketingActive ? 'page' : undefined}
        >
          {t('product_switcher.crm')}
        </button>
        <button
          type="button"
          className={tabClassName(marketingActive)}
          onClick={handleMarketingClick}
          aria-current={marketingActive ? 'page' : undefined}
        >
          {t('product_switcher.marketing')}
        </button>
      </nav>
    </div>,
    mountNode
  );
};

export default ProductSwitcherMC;
export { isMarketingProductPath };
